import { render, staticRenderFns } from "./BotaoPersonaSucursales.vue?vue&type=template&id=4756faf8&lang=pug"
import script from "./BotaoPersonaSucursales.vue?vue&type=script&lang=js"
export * from "./BotaoPersonaSucursales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports